<template>
  <DialogBase
    visible
    ref="dialog"
    :title="Title"
    icon="mdi-monitor-edit"
    midium
    complete
    close
    @clickComplete="complete(true)"
    @clickClose="close(false)"
  >
    <AttendanceSummaryFixForm v-model="summary" :header="header" />
  </DialogBase>
</template>
<script>
import Vue from "vue";

import AttendanceSummaryFixForm from "@/components/AttendanceSummaryFixForm.vue";

// mixins
import Common from "@/mixins/common";
import Dialog from "@/mixins/dialog";
// VueGoodTable
import "vue-good-table/dist/vue-good-table.css";
import Forms from "@/mixins/forms";
import Api from "@/mixins/api";
import ShowDialogs from "@/mixins/showDialogs";
import { SalaryCalc, SalaryCalcKey } from "@/models/SalaryCalc";
import {
  WelfareAttendanceSummaryFix,
  WelfareAttendanceSummaryFixHeader
} from "@/models/attendance/summary/WelfareAttendanceSummaryFix";

const welfareAttendanceSummaryFix = new WelfareAttendanceSummaryFix();

export default Vue.extend({
  name: "WelfareAttendanceSummaryFixDialog",
  mixins: [Common, Dialog, Forms, Api, ShowDialogs],
  components: { AttendanceSummaryFixForm },
  data: () => ({
    header: WelfareAttendanceSummaryFixHeader,
    targetmonth: "",
    user: {
      incode: "",
      name: ""
    },
    summary: welfareAttendanceSummaryFix
  }),
  computed: {
    Title() {
      const s = this.targetmonth.split("-");
      const title = s[0] + "年" + s[1] + "月 " + this.user.name + " 合計修正";
      return title;
    }
  },
  methods: {
    close(result) {
      this.resolve(result);
      this.$close();
    },
    async complete() {
      console.log("complete");

      try {
        const key = new SalaryCalcKey({
          paymentdate: this.getPaymentDate(),
          employeeId: this.user.incode,
          affiliationId: "-999"
        });
        const payload = new SalaryCalc({
          ...key,
          ...this.summary
        });
        console.log("salaryfix", payload);
        await this.$put(this.Paths.attendanceSalaryFix, payload);
        this.$info("更新しました。");
        this.$close(this.summary);
      } catch (e) {
        console.log("posterror", e);
        this.$error(e.message);
      }
    },
    getPaymentDate() {
      const ym = this.targetmonth.split("-");
      const dt = new Date(Number(ym[0]), Number(ym[1]), 1);
      dt.setDate(dt.getDate() - 1);

      const result =
        dt.getFullYear() +
        "-" +
        ("00" + Number(dt.getMonth() + 1)).slice(-2) +
        "-" +
        ("00" + dt.getDate()).slice(-2);

      return result;
    }
  },
  created() {
    console.log("created", this.args);
    this.targetmonth = this.args.targetmonth;
    this.user.incode = this.args.user.code;
    this.user.name = this.args.user.name;
    this.summary = this.args.summary;
  },
  mounted() {
    console.log("mounted", this.args);
  }
});
</script>
